import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {Input} from "@/components/ui/input.tsx";
import {FieldPath, FieldValues, useFormContext} from "react-hook-form";
import * as React from "react";
import {cn} from "@/lib/utils.ts";

export default function TextInputField<T extends FieldValues>(
    {name, title, className, ...props}:
        { name: FieldPath<T>, title?: string } & React.ComponentProps<"input">) {
    const {control} = useFormContext()

    return (
        <FormField control={control} name={name} render={({field}) => (
            <FormItem className={cn(className)}>
                {title && <FormLabel>{title}</FormLabel>}
                <FormControl>
                    <Input {...props} {...field} value={field.value ?? ""}/>
                </FormControl>
                <FormMessage/>
            </FormItem>
        )}/>)

}
